/**
 * Routes publiques du site marketing : une session expirée ne doit pas
 * rediriger vers /login (ex. blog SEO, landing).
 */
export function isPublicSessionRoute(pathname: string): boolean {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  return !p.startsWith('/app');
}

export function shouldRedirectToLoginOnSessionExpiry(pathname?: string): boolean {
  if (typeof window === 'undefined') return true;
  const p = pathname ?? window.location.pathname;
  return !isPublicSessionRoute(p);
}
